var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83463 0.166687H2.33464C1.41797 0.166687 0.667969 0.916687 0.667969 1.83335V15.1667C0.667969 16.0834 1.41797 16.8334 2.33464 16.8334H12.3346C13.2513 16.8334 14.0013 16.0834 14.0013 15.1667V4.33335L9.83463 0.166687ZM2.33464 15.1667V1.83335H9.0013V5.16669H12.3346V15.1667H2.33464Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3779 13.5002H8.67871L7.33105 11.2394L5.97852 13.5002H4.28906L6.4375 9.99921L4.28906 6.49823H5.97852L7.33105 8.75897L8.67871 6.49823H10.3779L8.22949 9.99921L10.3779 13.5002Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.a616a5a33a57851e713e5a07e9ea9907.svg";
export { ForwardRef as ReactComponent };